import {
  getClassRoomStudents,
  PatchClassRoomStatus,
  PostClassRoomBoardNewPage,
  PostClassRoomClose,
  // PostClassRoomStudentEnter,
  PostClassRoomStudentLeave,
} from '../apis/classRoom.ts'
import { useLocation, useOutletContext } from 'react-router-dom'
import { useEffect, useState } from 'react'
import ClassroomStudentModal from '../components/ClassroomStudentModal.jsx'
import { dayEnumList, statusList } from '../assets/data.js'
import {
  GridViewSwitch,
  LogOut,
  MainViewSwitch,
  ModeSwitch,
  Pagination,
  Participants,
  StartClass,
} from '../components/BoardButtonComponents.jsx'
import { DefaultModal, RadioModal, TimerModal } from '../components/BoardModal.jsx'
import ClassroomGrid from '../components/ClassroomGrid.jsx'
import LoadDocument from '../components/LoadDocument.jsx'
import LoadBoard from '../components/LoadBoard.jsx'
// import { useEffect, useState } from 'react'

export default function BoardView({ userComponent }) {
  const {
    classroomInfo,
    boardList,
    currentPage,
    setCurrentPage,
    postClassRoomInfoApi,
    postClassRoomOpenApi,
    socketEventResponse,
    connect,
    studentBoardsGridList,
    currentStudentNum,
    setCurrentStudentNum,
    setIsSideBarFold,
    getClassRoomStudentBoardsGridApi,
    getClassRoomBoardApi,
    viewType,
    handleViewType,
    sideBarWidth,
  } = useOutletContext()
  const location = useLocation()
  // const navigate = useNavigate()
  // const history = useHistory()
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false)
  const [isLogOutModalOpen, setIsLogOutModalOpen] = useState(false)
  const [isModeModalOpen, setIsModeModalOpen] = useState(false)
  const [isTimerModalOpen, setIsTimerModalOpen] = useState(false)
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false)
  const [isBoardModalOpen, setIsBoardModalOpen] = useState(false)
  const [isGridOpen, setIsGridOpen] = useState(false)

  const findItem = (list, pageNum) => {
    const item = list?.find((item) => item?.pageNum === pageNum)
    return item
  }

  const findStudent = () => {
    const item = studentBoardsGridList?.find((item) => item?.studentNum === currentStudentNum)
    return item
  }

  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 5000)

    return () => clearTimeout(timer)
  }, [isVisible])

  /*************** 수업방 입장 학생 목록 API **************/
  useEffect(() => {
    if (classroomInfo?.id) {
      getClassRoomStudentsApi(classroomInfo?.id)
    }
    // eslint-disable-next-line
  }, [classroomInfo?.id])

  const [studentList, setStudentList] = useState([])
  const getClassRoomStudentsApi = async (classroomId) => {
    const getClassRoomStudentsResponse = await getClassRoomStudents({
      classroomId: classroomId,
    })

    if (getClassRoomStudentsResponse.error) {
      console.log(getClassRoomStudentsResponse)
      return
    } else {
      // console.log(getClassRoomStudentsResponse.data)
      setStudentList(getClassRoomStudentsResponse.data)
    }
  }

  /*************** 수업방 종료 API **************/
  const postClassRoomCloseApi = async (classroomId) => {
    const postClassRoomCloseResponse = await PostClassRoomClose({
      classroomId: classroomId,
    })
    if (postClassRoomCloseResponse.error) {
      console.log(postClassRoomCloseResponse.message)
      return
    } else {
      console.log(postClassRoomCloseResponse.data)
    }
  }

  /*************** 새 페이지 추가 API **************/
  const postClassRoomBoardNewPageApi = async (currentPage) => {
    const postClassRoomBoardNewPageResponse = await PostClassRoomBoardNewPage(
      { classroomId: classroomInfo.id },
      {
        currentPageNumber: currentPage,
      },
    )
    if (postClassRoomBoardNewPageResponse.error) {
      console.log(postClassRoomBoardNewPageResponse.error)
      return
    } else {
      // console.log(postClassRoomBoardNewPageResponse.data)
      // await getApi()
      setCurrentPage(postClassRoomBoardNewPageResponse.data)
    }
  }

  /*************** 수업방 상태 변경 API **************/
  const patchClassRoomStatusApi = async (mode, currentPage, gridMode, studentBoardId) => {
    const patchClassRoomStatusResponse = await PatchClassRoomStatus(
      {
        classroomBoardId: boardList?.find((item) => item.pageNum === currentPage)?.id,
      },
      {
        mode: mode,
        // allowStudentEdit: edit,
        lastViewedPage: currentPage,
        isGridView: gridMode,
        studentBoardId: studentBoardId,
      },
    )

    if (patchClassRoomStatusResponse.error) {
      console.log(patchClassRoomStatusResponse.error)
      return
    } else {
      console.log(patchClassRoomStatusResponse.result)
      // setIsVisible(true)
    }
  }

  /*************** 학생 수업방 입장 API **************/
  // const postClassRoomStudentEnterApi = async (studentId) => {
  //   const postClassRoomStudentLeaveResponse = await PostClassRoomStudentEnter({
  //     sessionId: location.state.sessionData.id,
  //     // classroomId: 'bdbf8158-320b-40c7-a666-abfd5377a491',
  //     studentId: studentId,
  //   })
  //   if (postClassRoomStudentLeaveResponse.error) {
  //     console.log(postClassRoomStudentLeaveResponse.error)
  //     return
  //   } else {
  //     console.log(postClassRoomStudentLeaveResponse.result)
  //   }
  // }

  /*************** 학생 수업방 퇴장 API **************/
  const postClassRoomStudentLeaveApi = async (studentId) => {
    const postClassRoomStudentLeaveResponse = await PostClassRoomStudentLeave({
      classroomId: classroomInfo?.id,
      studentId: studentId,
    })
    if (postClassRoomStudentLeaveResponse.error) {
      console.log(postClassRoomStudentLeaveResponse.error)
      return
    } else {
      console.log(postClassRoomStudentLeaveResponse.result)
      getClassRoomStudentsApi(classroomInfo?.id)
    }
  }

  const findActiveStudent = () => {
    const enteringStudents = []
    studentList?.forEach((item) => {
      if (item.isActive) {
        enteringStudents.push(item.id)
      }
    })
    return enteringStudents
  }

  const [hasTimerStateChanged, setHasTimerStateChanged] = useState(false)
  const [lastViewedPage, setLastViewedPage] = useState()

  useEffect(() => {
    if (socketEventResponse?.type.includes('INDIVIDUAL')) {
      if (lastViewedPage === currentPage) {
        setIsTimerModalOpen(false)
        setHasTimerStateChanged(false)
      } else {
        if (!hasTimerStateChanged) {
          setIsTimerModalOpen(true)
          setHasTimerStateChanged(true)
        }
      }
    }
    // eslint-disable-next-line
  }, [currentPage])

  useEffect(() => {
    setLastViewedPage(currentPage)
    setHasTimerStateChanged(false)
    if (socketEventResponse?.type === 'CLOSE') {
      postClassRoomInfoApi()
    }
    // eslint-disable-next-line
  }, [socketEventResponse?.type])

  useEffect(() => {
    if (boardList.length > 0) {
      patchClassRoomStatusApi(null, currentPage)
    }
    // eslint-disable-next-line
  }, [currentPage])

  return (
    <div
      className={`${boardList.length === 0 ? 'items-center justify-center bg-label-default' : ''} relative flex h-full w-full bg-contain bg-center bg-no-repeat`}
      style={{
        backgroundImage:
          classroomInfo?.status === 'COMPLETED'
            ? `url(${findStudent()?.studentBoard.backgroundImageUrl})`
            : socketEventResponse?.type.includes('FOCUS_GRID')
              ? `url(${socketEventResponse?.data.backgroundImageUrl})`
              : `url(${findItem(boardList, currentPage)?.backgroundImageUrl})`,
      }}
    >
      {/* <userComponent /> */}
      {/* 상단 */}
      <div className='board:top-16 absolute left-0 top-8 z-[1000]'>
        <div className='board:gap-12 flex items-center gap-8'>
          <div className='board:px-20 board:py-8 board:rounded-r-10 tab:rounded-r-8 tab:gap-12 tab:py-10 tab:px-12 board:gap-16 board:border-y-2 board:border-r-2 flex items-center gap-12 rounded-r-6 border-y-[1px] border-r-[1px] border-solid border-border-default bg-background-default px-12 py-4 shadow-emphasize 3xl:px-24 3xl:py-12'>
            <p className='tab:text-h2-medium text-body3-semibold text-label-sub 3xl:text-h1-medium'>{`${location.state.classData.subject.name} ${location.state.classData.className}`}</p>
            <div className='board:h-36 board:w-2 h-24 w-[1px] bg-border-default' />
            <p className='text-caption2-regular tab:text-body1-regular text-label-sub 3xl:text-h2-regular'>{`${location.state.sessionData.week}주차 ${location.state.sessionData.order}차시 ${dayEnumList[location.state.sessionData.dayOfWeek]} ${location.state.sessionData.period}교시`}</p>
          </div>
          <div
            className='text-caption2-semibold tab:text-caption-semibold board:text-body2-semibold tab:px-8 rounded-4 px-6 py-4 text-static-white'
            style={{ backgroundColor: statusList[classroomInfo?.status]?.color }}
          >
            {statusList[classroomInfo?.status]?.text}
          </div>
        </div>
      </div>
      {(socketEventResponse?.type.includes('GRID') ||
        (viewType === 'GRID' && currentStudentNum)) && (
        <div
          style={{ right: `calc(${sideBarWidth}px + 8px)` }}
          className='board:px-20 board:py-12 tab:py-8 absolute right-20 top-[26px] flex items-center gap-8 rounded-90 border border-border-strong bg-background-default px-12 py-6 shadow-emphasize'
        >
          <p className='board:text-h2-semibold text-body3-semibold text-label-info'>{`${findStudent()?.studentNum} | ${findStudent()?.student.name}`}</p>
          <div className='h-16 w-[1px] bg-label-info' />
          <p
            className={`${findStudent()?.student.isActive ? 'text-border-active' : 'text-label-placeholder'} text-caption2-semibold board:text-body1-long-semibold tab:text-caption-medium`}
          >
            {findStudent()?.student.isActive ? `접속중` : `미접속`}
          </p>
        </div>
      )}
      {boardList.length === 0 && (
        <div className='flex flex-col items-center gap-40'>
          <p className='whitespace-pre-wrap text-center text-title2-bold text-static-white'>{`현재 보드가 없습니다
새 보드를 추가하거나 자료 또는 보드를 불러오세요`}</p>
          <div className='flex items-center gap-16'>
            <button
              onClick={async () => {
                await postClassRoomBoardNewPageApi(0)
                getClassRoomBoardApi()
              }}
              className='button_solid_primary_lg'
            >
              새 보드 추가하기
            </button>
            <button
              onClick={() => setIsDocumentModalOpen(true)}
              className='button_solid_primary_lg'
            >
              자료 불러오기
            </button>
            <button onClick={() => setIsBoardModalOpen(true)} className='button_solid_primary_lg'>
              보드 불러오기
            </button>
          </div>
        </div>
      )}
      {/* 하단 */}
      {boardList.length === 0 ? (
        <div className='board:bottom-16 board:right-16 tab:bottom-12 tab:right-12 absolute bottom-8 right-8'>
          <LogOut modalState={isLogOutModalOpen} setModalState={() => setIsLogOutModalOpen(true)} />
        </div>
      ) : (
        <>
          {classroomInfo?.status === 'ONGOING' && !isGridOpen && (
            <div className='board:left-[397px] tab:bottom-12 board:bottom-16 fixed bottom-8 left-[188px]'>
              <Participants
                modalState={() => setIsStudentModalOpen(true)}
                // modalState={() => navigate('/board/student', { state: { ...location.state } })}
                data={studentList}
              />
            </div>
          )}
          {!isGridOpen && (
            <div
              className={`tab:bottom-12 board:bottom-16 board:left-1/2 board:-translate-x-1/2 fixed bottom-8 ${sideBarWidth === 2 ? 'left-1/2 -translate-x-1/2' : 'tab:-translate-x-[200px] board:-translate-x-1/2 left-1/2 -translate-x-[100px]'}`}
            >
              <Pagination
                data={
                  socketEventResponse?.type.includes('GRID') ? studentBoardsGridList : boardList
                }
                currentPage={
                  socketEventResponse?.type.includes('GRID') ? currentStudentNum : currentPage
                }
                setCurrentPage={
                  socketEventResponse?.type.includes('GRID') ? setCurrentStudentNum : setCurrentPage
                }
                mode={socketEventResponse ? socketEventResponse.type : classroomInfo?.mode}
                studentBoardsGridList={studentBoardsGridList}
                patchApi={(page) => {
                  if (socketEventResponse?.type.includes('GRID')) {
                    patchClassRoomStatusApi(null, currentPage, true, findStudent().studentBoard.id)
                  }
                  if (socketEventResponse?.type === 'FOCUS') {
                    patchClassRoomStatusApi('FOCUS', page)
                  }
                }}
              />
            </div>
          )}
          <div
            className='board:gap-12 tab:bottom-12 board:bottom-16 tab:gap-8 absolute bottom-8 flex items-center gap-6'
            style={{ right: `calc(${sideBarWidth}px + 8px)` }}
          >
            {isGridOpen ? (
              <MainViewSwitch
                modalState={isGridOpen}
                onStateChange={() => {
                  setIsGridOpen((prev) => !prev)
                  // handleViewType()
                  // patchClassRoomStatusApi(socketEventResponse?.mode, currentPage, false, null)
                }}
              />
            ) : socketEventResponse?.type.includes('GRID') || viewType === 'GRID' ? (
              <>
                <GridViewSwitch
                  onStateChange={() => {
                    setIsGridOpen(true)
                    // patchClassRoomStatusApi(socketEventResponse?.type, currentPage, true, null)
                  }}
                />
                <MainViewSwitch
                  modalState={isGridOpen}
                  onStateChange={() => {
                    // setIsGridOpen(false)
                    patchClassRoomStatusApi(socketEventResponse?.mode, currentPage, false, null)
                    handleViewType()
                  }}
                />
              </>
            ) : (
              (studentBoardsGridList?.length > 0 || socketEventResponse?.data.hasSubBoards) && (
                <GridViewSwitch
                  onStateChange={() => {
                    setIsGridOpen(true)
                    handleViewType()
                    // patchClassRoomStatusApi(socketEventResponse?.type, currentPage, true, null)
                  }}
                />
              )
            )}
            {classroomInfo?.status === 'ONGOING' && (
              <ModeSwitch
                mode={socketEventResponse ? socketEventResponse.type : classroomInfo?.mode}
                modeModalState={isModeModalOpen}
                gridState={isGridOpen}
                disabledState={
                  socketEventResponse?.type === 'INDIVIDUAL' && currentPage !== lastViewedPage
                }
                onStateChange={() => {
                  setIsModeModalOpen(true)
                  setIsSideBarFold(true)
                }}
                // patchApi={(mode, gridMode, boardId) =>
                //   patchClassRoomStatusApi(mode, currentPage, gridMode, boardId)
                // }
                socketEventResponse={socketEventResponse}
                getGridApi={() => getClassRoomStudentBoardsGridApi()}
              />
            )}

            {classroomInfo?.isOpenPossible && classroomInfo?.status === 'UPCOMING' && (
              <div
                onClick={async () => {
                  await postClassRoomOpenApi(classroomInfo?.id)
                  connect()
                  postClassRoomInfoApi()
                }}
              >
                <StartClass />
              </div>
            )}
            <div
              onClick={async () => {
                await postClassRoomOpenApi(classroomInfo?.id)
                connect()
                postClassRoomInfoApi()
              }}
            >
              <p className='button_outlined_assistive_sm'> test</p>
            </div>
            <LogOut
              modalState={isLogOutModalOpen || isGridOpen}
              onStateChange={() => {
                if (classroomInfo?.status === 'ONGOING') {
                  setIsLogOutModalOpen(true)
                }
              }}
              // link={classroomInfo?.status !== 'ONGOING' ? '/class/detail' : null}
              // locationState={
              //   classroomInfo?.status !== 'ONGOING' ? location.state.classData : null
              // }
            />
          </div>
        </>
      )}
      {isVisible && (
        <div className='board:px-20 board:py-16 board:bottom-[84px] tab:px-16 tab:py-12 tab:bottom-64 fixed bottom-[44px] left-1/2 -translate-x-1/2 rounded-90 border border-border-active bg-background-secondary px-12 py-8 shadow-emphasize'>
          <p className='text-caption2-medium tab:text-body3-medium board:text-h1-medium text-border-active'>
            {socketEventResponse?.type.includes('FOCUS')
              ? `수업 집중이 실행되었습니다`
              : `개인 보드 생성 및 이동을 완료했습니다`}
          </p>
        </div>
      )}
      {isStudentModalOpen && (
        <ClassroomStudentModal
          close={() => setIsStudentModalOpen(false)}
          studentList={studentList}
        />
      )}
      {isLogOutModalOpen && (
        <RadioModal
          content={'exitRoom'}
          close={() => setIsLogOutModalOpen(false)}
          postApi={async () => {
            postClassRoomCloseApi(classroomInfo?.id)
          }}
          studentsLeaveApi={async () => {
            for (const item of findActiveStudent()) {
              await postClassRoomStudentLeaveApi(item)
            }
          }}
          onStateChange={() => setIsCloseModalOpen(true)}
        />
      )}
      {isCloseModalOpen && (
        <DefaultModal content={'logout'} close={() => setIsCloseModalOpen(false)} />
      )}
      {isGridOpen && (
        <ClassroomGrid
          gridData={studentBoardsGridList}
          onStateChange={() => setIsGridOpen(false)}
          data={location.state}
          patchApi={(studentBoardId) =>
            patchClassRoomStatusApi(socketEventResponse?.mode, currentPage, true, studentBoardId)
          }
          setCurrentStudentNum={setCurrentStudentNum}
        />
      )}
      {isModeModalOpen && (
        <DefaultModal
          content={
            (socketEventResponse?.type || classroomInfo?.mode).includes('FOCUS')
              ? socketEventResponse?.data.hasSubBoards
                ? 'individualAlready'
                : 'individual'
              : 'focus'
          }
          close={() => {
            setIsModeModalOpen(false)
            // setButtonId()
          }}
          currentPage={currentPage}
          students={studentList.length}
          setCurrentPage={setCurrentPage}
          api={async () => {
            if (socketEventResponse?.type === 'INDIVIDUAL_GRID') {
              patchClassRoomStatusApi('FOCUS', currentPage, true, findStudent().studentBoard.id)
              setIsVisible(true)
              return
            }
            if (socketEventResponse?.type === 'FOCUS_GRID') {
              patchClassRoomStatusApi(
                'INDIVIDUAL',
                currentPage,
                true,
                findStudent().studentBoard.id,
              )
              setIsVisible(true)
              return
            } else {
              await patchClassRoomStatusApi(
                (socketEventResponse?.type || classroomInfo?.mode) === 'FOCUS'
                  ? 'INDIVIDUAL'
                  : 'FOCUS',
                currentPage,
              )
              getClassRoomStudentBoardsGridApi(currentPage)
              setIsVisible(true)
              return
            }
            // await getClassRoomStudentBoardsGridApi()
          }}
        />
      )}
      {isTimerModalOpen && (
        <TimerModal
          // content={'focusWhileIndividual'}
          close={() => setIsTimerModalOpen(false)}
          currentPage={lastViewedPage}
          api={async () => {
            patchClassRoomStatusApi('FOCUS', currentPage)
            setIsVisible(true)
          }}
        />
      )}
      {isDocumentModalOpen && (
        <LoadDocument
          close={() => setIsDocumentModalOpen(false)}
          subjectId={location.state.classData.subject.id}
          currentPage={0}
          classroomId={classroomInfo.id}
          getApi={() => {
            getClassRoomBoardApi()
            // setSelectedSlide([])
            // setIsSelectedMode(false)
          }}
          setCurrentPage={setCurrentPage}
        />
      )}
      {isBoardModalOpen && (
        <LoadBoard
          close={() => setIsBoardModalOpen(false)}
          courseId={location.state.sessionData.courseId}
          currentPage={0}
          classroomId={classroomInfo.id}
          getApi={() => {
            getClassRoomBoardApi()
            // setSelectedSlide([])
            // setIsSelectedMode(false)
          }}
          setCurrentPage={setCurrentPage}
        />
      )}
    </div>
  )
}
